import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import IsolationGroupsResource from "@ane/exp-data/lib/resources/expapiv2/IsolationGroups.resource";
import { prefix } from "./constants.js";
import { resetUpdateResult } from "./actions.js";
import { replaceIsolationGroup } from "../../common/epics/actions.js";
const updateIsolationGroupEpicReducerArgs = {
  actionPrefix: `${prefix}/UPDATE`,
  reduxKeyNested: () => ["updateResult"],
  loadResource: (inputPayload) => IsolationGroupsResource.updateIsolationGroup(inputPayload.workspaceId, inputPayload.id, inputPayload.data),
  onCompleteSuccess: (resourceResult, inputPayload) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    replaceIsolationGroup(outputPayload),
    resetUpdateResult()
  ]
};
const updateIsolationGroupEpicReducer = loadResourcesUtils(updateIsolationGroupEpicReducerArgs);
const rootEpic = combineEpics(updateIsolationGroupEpicReducer.epic);
export {
  rootEpic as default,
  rootEpic,
  updateIsolationGroupEpicReducer
};
//# sourceMappingURL=epics.js.map
